import isFinite from 'lodash/isFinite';
import {AddPartActionsheet} from '~/components/shared/Actionsheets';
export const updateExistingPart = (
  existing,
  editArticle,
  {
    id,
    reference,
    number,
    source,
    description,
    brand,
    price,
    margin,
    quantity,
    gen_art_nr,
    specifications,
  },
) => ({
  ...existing,
  reference,
  number,
  source: source ?? editArticle.task_part?.source,
  description,
  price,
  gen_art_nr,
  quantity:
    isFinite(editArticle.task_part?.quantity) &&
    editArticle.task_part?.quantity !== 1
      ? editArticle.task_part?.quantity
      : Math.max(
          editArticle.task_part?.quantity ?? 0,
          editArticle.amounts,
          quantity ?? 0,
          1,
        ),
  attributes: {
    ...existing.attributes,
    itemMpId: editArticle.itemMpId,
    matching_code: id,
    margin,
    brand,
  },
  specifications,
});
export const PartSelection = ({
  request_id,
  dealer_id,
  license,
  parts,
  lessor,
  rob_code,
  onChange,
  onDismiss,
}) => (
  <AddPartActionsheet
    request_id={request_id}
    dealer_id={dealer_id}
    license={license}
    parts={Object.values(parts).map((item) => ({
      ...item,
      id: item.itemMpId ?? item.attributes.itemMpId,
    }))}
    lessor={lessor}
    rob_code={rob_code}
    onChange={onChange}
    onDismiss={onDismiss}
  />
);
